import { render, staticRenderFns } from "./RecentPdfButton.vue?vue&type=template&id=fe55cf3e&"
import script from "./RecentPdfButton.vue?vue&type=script&lang=js&"
export * from "./RecentPdfButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports